import { axiosWrapper } from "./axiosService";
import Firebase from "../services/firebase";
import axios from "axios";
export const wpUrl = getWpAjaxUrl();

// --------------------------------------------------------
// CUSTOMERS
// --------------------------------------------------------
/**
 * @param {object}
 * @param {string} mail
 * @returns {object} api response
 */
export const getCustomerByMail = ({ mail }) => {
	const url = `/customers/${mail}`;
	return axiosWrapper({ method: "get", url });
};
/**
 * @param {object}
 * @param {string} name
 * @param {string} mail
 * @returns {object} api response
 */
export const createCustomer = ({ name, mail }) => {
	const url = `/customers?upsert=true`;
	const data = { name, mail, channel: process.env.REACT_APP_CHANNEL || "wp" };
	return axiosWrapper({ method: "post", url, data });
};
// --------------------------------------------------------
// PLANS
// --------------------------------------------------------
/**
 * @param {object}
 * @param {string} cust_id
 * @returns {object} api response
 */
export const getPlansByCustomerId = async ({ cust_id }) => {
	const url = `/plans?cust_id=${cust_id}`;
	return await axiosWrapper({ method: "get", url });
};
/**
 * @param {object}
 * @param {string} mail
 * @returns {object} api response
 */
export const getPlansByMail = async ({ mail }) => {
	const url = `/plans?mail=${encodeURIComponent(mail)}`;
	return await axiosWrapper({ method: "get", url });
};
/**
 * @param {object}
 * @param {number || string} cust_id
 * @param {string} type (Trial)
 * @param {string} name (chanel name)
 * @returns {object} api response
 */
export const createPlan = async ({ cust_id, name, mail }) => {
	const url = `/plans`;
	const data = { cust_id, name, mail, type: "Trial" };
	return await axiosWrapper({ method: "post", url, data });
};
/**
 * Patch plan function
 * @param {} planId
 * @param {*} data
 * @returns {Promise}
 */
export function patchPlan(planId, data) {
	return axiosWrapper({ method: "patch", url: `/plans/${planId}`, data });
}
/**
 * Cancel plan
 * @param {string} planId  - stripe sub id to cancel
 * @return Promise
 */
export function cancelPlan(planId) {
	return axiosWrapper({ method: "delete", url: `/billing/${planId}` });
}
// --------------------------------------------------------
// COUPONS
// --------------------------------------------------------
/**
 * Validate Coupon
 * @param {*} coupon
 * @returns {promise}
 */
export const validateCoupon = async (coupon) => {
	if (!coupon) throw new Error("Coupon input must be forwarded");
	return await axiosWrapper({ method: "get", url: `/billing/coupons/${coupon}` });
};
// --------------------------------------------------------
// SEGMENTS
// --------------------------------------------------------
/**
 * @param {object}
 * @param {string} id
 * @param {string[]} extras = ["hits", "prevHits", "audiences"]
 * @param {string} time_frame
 * @returns {object} api response
 */
export const getSegmentsById = async ({ id, time_frame, extras }) => {
	let url = `/segments/${id}`;
	const params = { time_frame };
	if (extras && extras.length) params.extras = JSON.stringify(extras);
	return await axiosWrapper({ method: "get", url, params });
};
/**
 * @param {object}
 * @param {string} mail
 * @param {string[]} extras = ["hits", "prevHits", "audiences"]
 * @param {string} time_frame
 * @returns {object} api response
 */
export const getSegmentsByMail = async ({ mail, time_frame, extras }) => {
	let url = `/segments`;
	const params = { mail, time_frame };
	if (extras && extras.length) params.extras = JSON.stringify(extras);

	return process.env.NODE_ENV === "development" ?
					await axiosWrapper({ method: "get", url, params }) :
					await formDataWithToken({action: "fxl_get_segments_by_mail",...params});
};
/**
 * @param {object}
 * @param {string} mail
 * @param {string} name
 * @returns {object} api response
 */
export const createSegment = async ({ mail, name }) => {
	const url = `/segments`;
	const data = { mail, display: name, channel: process.env.REACT_APP_CHANNEL || "wp", action: "fxl_create_segment" };
	return  process.env.NODE_ENV !== "production" ?
		await axiosWrapper({ method: "post", url, data }) :
		formDataWithToken(data)
};

/**
 * @param {object}
 * @param {string} id
 * @param {object} data
 * @returns {object} api response
 */
export const updateSegment = ({ id, data }) => {
	let url = `/segments/${id}`;
	return axiosWrapper({ method: "patch", url, data });
};
// --------------------------------------------------------
// HITS
// --------------------------------------------------------
/**
 * @param {object}
 * @param {string} id
 * @param {boolean} previous
 * @param {string} time_frame
 * @returns {object} api response
 */
export const getHitsById = async ({ id, time_frame, previous }) => {
	let url = `/hits/${id}`;
	const params = { reduce: true, time_frame, previous };
	return await axiosWrapper({ method: "get", url, params });
};
/**
 * @param {string} code
 * @param {string} time_frame
 * @returns {object} [time_frame].current = {total, high, medium, basic}
 * @returns {object} [time_frame].prev = {total, high, medium, basic}
 */
export const getHitsByTimeFrame = async (code, time_frame) => {
	const current = await getHitsById({ id: code, time_frame });
	const prev = await getHitsById({ id: code, time_frame, previous: true });
	return { [time_frame]: { current: current.data, prev: prev.data } };
};
// --------------------------------------------------------
// FACEBOOK
// --------------------------------------------------------
/**
 * @param {object}
 * @param {string} id
 * @param {string} token
 * @returns {promise}
 */
export const getFacebookAccounts = async ({ id, token }) => {
	const url = `/platforms/accounts/${id}?token=${token}`;
	return await axiosWrapper({ method: "get", url });
};
/**
 * @param {object} data
 * @returns {promise}
 */
export const setAudiences = async (data) => {
	const url = `/platforms/audiences`;
	return await axiosWrapper({ method: "post", url, data });
};
/**
 * @param {string} fxl_code
 * @returns {promise}
 */
export const getAudiences = async (fxl_code) => {
	const url = `/platforms/audiences?fxl_code=${fxl_code}`;
	return await axiosWrapper({ method: "get", url });
};
/**
 * @param {string} fxl_code
 * @param {object} data
 * @returns {promise}
 */
export const patchAudiences = async (fxl_code, data) => {
	const url = `/platforms/audiences?fxl_code=${fxl_code}`;
	return await axiosWrapper({ method: "patch", url, data });
};

// --------------------------------------------------------
// UTILS
// --------------------------------------------------------
/**
 * Clean url and return display name
 * @param {*} name
 * @returns {string}
 */
export const cleanName = (name) => {
	let url = name.replace("https://", "").replace("http://", "").replace("www.", "").split(".");
	const [displayName] = url;
	return displayName;
};

/**
 * 
 * @param {*} location 
 * @returns 
 */
export const shouldGoToLoadingPage = (location) => {
	const redirectToLoadingPage = ["/login", "/signup", "/password-reset", "/start", "/start/platform", "/start/platform/shopify", "/start/platform/wordpress"];
	return redirectToLoadingPage.includes(location.pathname);
};

/**
 *
 * @param pathname
 * @returns {string}
 */
export const getPageTitle = (pathname) => {
  if (pathname && typeof pathname === "string") {
    if (pathname.includes("login")) return "Login | Fixel";
    if (pathname.includes("dashboard")) return "Home | Fixel";
    if (pathname.includes("plans")) return "Plans | Fixel";
    if (pathname.includes("support")) return "Support | Fixel";
    if (pathname.includes("segments")) return "Segments | Fixel";
    if (pathname.includes("error-page")) return "Error | Fixel";
    return "Fixel";
  }
};


/**
 *
 * @returns {string|string|*}
 */
function getWpAjaxUrl() {
	if(window.ajaxurl){
		return window.ajaxurl;
	}
	if(process.env.wpUrl){
		return process.env.wpUrl;
	}else {
		return `${window.location.protocol}//${window.location.hostname}/wp-admin/`;
	}
}

/**
 * Create a form data request via axios
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const formDataWithToken = async (data) => {
	const form_data = formDataFromObj(data);
	await withToken(form_data);
	return axios.post(wpUrl, form_data);
}

/**
 *
 * @param data
 * @returns {FormData}
 */
export function formDataFromObj(data){
	const form_data = new FormData();
	for (let [key, value] of Object.entries(data)) {
		if(typeof value === 'object' && value !== null){
			value = JSON.stringify(value);
		}
		form_data.append(key, value);
	}
	return form_data;
}

/**
 *
 * @param data
 * @returns {Promise<void>}
 */
export async function withToken(data){
	const token = sessionStorage.token || (await Firebase.getUserToken());
	data.append('token',token);
}

/**
 *
 * @param url
 * @returns {string}
 */
export const getHostname = (url) => {
	try {
		let u = window.location.hostname.split('.co')[0];
		u = u.includes('www.')? u.split('www.')[1]:u;
		return u;
	}catch (e) {
		return window.location.hostname;
	}
}